<script>
  import { onMount } from "svelte";
  import { user } from "../firebase.js";
  import { createEventDispatcher } from "svelte";
  export let file;
  console.log(file);
  let done = false;
  let progress = 0;
  const dispatch = createEventDispatcher();
  onMount(async () => {
    let link = await $user.create.file(file, (localprogress) => {
      console.log(localprogress);
      progress = localprogress;
    });
    if ((progress = 100.0)) {
      console.log("FILE", link);
      let temp = link.name.split(".");
      let type = temp[temp.length - 1];
      link["type"] = type;
      done = true;
      console.log(link);
      dispatch("confirm", link);
    }

    console.log(link);
  });
</script>

<div class="upload-item">
  <div class:done class="u-name">
    {file.name}
  </div>
  <div style="width:{progress}%" class:over={done} class="u-progress" />
</div>

<style>
  .upload-item {
    margin: 0 0.7rem;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .u-name {
    font-size: 0.875em;
    transition: color 0.8s ease;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .u-progress {
    background-color: var(--primaryColor);
    height: 5px;
    display: flex;
    transition: all 0.8s ease;
    width: 0;
  }

  .done {
    color: var(--primaryColor);
    transition: color 0.8s ease;
  }

  .over {
    opacity: 0;
    transition: all 0.8s ease;
  }
</style>
